import React from 'react';
import { useHistory } from 'react-router-dom'
import useAuth from '../hooks/useAuth';
import { Box, Button, Grid, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import Drawer from '@mui/material/Drawer';
import SideBar from './SideBar';
import Logo from './Logo';

function SiteHeader() {
  const history = useHistory()
  const { user } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Dynamic logo sizing based on current route
  const isDashboard = history.location.pathname.includes('/dashboard');
  const baseMobileHeight = isDashboard ? 64 : 96; // Dashboard: double, Auth pages: triple
  const baseDesktopHeight = isDashboard ? 80 : 120; // Dashboard: double, Auth pages: triple

  const [sidebar, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <div className="authHeader">
      <Box sx={{ backgroundColor: '#1a1d26' }} padding={{ xs: 1, sm: 2 }}>
        <Grid item container justifyContent={'space-between'} alignItems="center">
          <Grid item>
            <Box display={{xs:'inline-flex', lg:'none'}} alignItems={'center'}>
              <IconButton  
                sx={{
                  color:'#fff',
                  p: { xs: 1, sm: 1.5 }
                }} 
                onClick={toggleDrawer(true)}
              >
                <MenuOpenIcon sx={{color:'#fff'}}/>
              </IconButton>
              <Box ml={1.5}>
                <Logo 
                  height={isMobile ? baseMobileHeight : baseDesktopHeight}
                  variant="white"
                  sx={{ 
                    maxHeight: { xs: `${baseMobileHeight}px`, sm: `${baseDesktopHeight}px` }
                  }}
                />
              </Box>
            </Box>
            <Drawer 
              open={sidebar} 
              onClose={toggleDrawer(false)}
              anchor="left"
              sx={{
                '& .MuiDrawer-paper': {
                  width: { xs: '280px', sm: '320px' },
                  backgroundColor: '#1a1d26',
                  color: '#fff'
                }
              }}
            >
              <SideBar setOpen={setOpen}/>
            </Drawer>
          </Grid>
          <Grid item>
            <Grid item container>
              <Box>
                <Button
                  id="demo-positioned-button"
                  aria-haspopup="true"
                  onClick={() => history.push(user.userType === "superAdmin" ? '/profile' : '/company/profile')}
                  sx={{
                    color:'#fff',
                    backgroundColor:'transparent !important',
                    fontSize: { xs: '0.875rem', sm: '1rem' },
                    px: { xs: 1, sm: 2 },
                    py: { xs: 0.5, sm: 1 }
                  }}
                >
                  {user?.userType === "company" ? user?.companyName : "Admin"}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

SiteHeader.propTypes = {};

export default SiteHeader;
